import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    padding: 5,
    margin: -5,
  },
  previewToggle: {
    marginLeft: 4,
    marginTop: -1,
    width: 25,
    height: 25,
  },
}));

export default useStyles;
